import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import api from "../../../api/api";
// import EditModal from "../../";
import EditAddList from "./EditAddList";

const AdsList = () => {
  const [adsList, setAdsList] = useState([]);
  const [addDelete, setDeleteAdd] = useState(false);
  const [adsId, setAdsId] = useState(0);
  const [viewMore, setViewMore] = useState(true)


  useEffect(() => {
    api
      .get("/advertisement/")
      .then((response) => {
        // console.log(response.data)
        setAdsList(response.data);
        // toast.success("Ads created successfully")
      })
      .catch((error) => {
        // console.log(error)
        toast.error(error);
      });
  }, []);

  
  const deleteAdd = (id) => {
    api
      .delete(`/advertisement/${id}/`)
      .then((response) => {
        // console.log(response.data);
        setAdsList(
          adsList.filter((adsList) => {
            return adsList.id !== id;
          })
        );
        toast.success("Ads deleted successfully");
      })
      .catch((error) => {
        toast.error("Something went wrong");
      });
  };

  const handleSearch = (e) => {
    api.get(`/advertisement/?search=${e.target.value}`)
    .then(response=> {
      setAdsList(response.data);
    })
    .catch(error=> {
      console.log(error)
    })
  }






  return (
    <div className="">
      <h1 className="text-primary-red mt-2 text-center text-3xl font-bold lg:!mt-6">
        Ads List
      </h1>

      <div className="">
        <img
          src="../../images/title-border.png"
          alt=""
          className="mx-auto mt-4"
        />
      </div>

      {/* table  */}
      <div className="mt-3 w-full md:px-10">
        <div className="flex flex-col">
          <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-4 sm:px-6 lg:px-8">
              <div className="overflow-x-scroll">
                {/* search */}
                <div className="flex flex-wrap items-center justify-between">
                  <input
                    type="text"
                    placeholder="Search by date "
                    id="table-search"
                    onChange={(e)=> handleSearch(e)}
                    className="mb-2 block w-80 rounded-lg border border-gray-700 bg-gray-50 py-2.5 px-3 text-sm focus:border-blue-500 focus:ring-blue-500"
                  />
                  <input
                    type="text"
                    placeholder="Search by name "
                    id="table-search"
                    onChange={(e)=> handleSearch(e)}
                    className="mb-2 block w-80 rounded-lg border border-gray-700 bg-gray-50 py-2.5 px-3 text-sm focus:border-blue-500 focus:ring-blue-500"
                  />
                  <input
                    type="text"
                    placeholder="Search by category "
                    id="table-search"
                    onChange={(e)=> handleSearch(e)}
                    className="mb-2 block w-80 rounded-lg border border-gray-700 bg-gray-50 py-2.5 px-3 text-sm focus:border-blue-500 focus:ring-blue-500"
                  />
                </div>
                <div className="">
                  <table className="min-w-full text-center">
                    <thead className="font-Bree bg-primary-red border-b font-bold">
                      <tr>

                        <th
                          scope="col"
                          className="px-6 py-4 text-sm font-medium text-white"
                        >
                          SN.
                        </th>
                        
                        <th
                          scope="col"
                          className="px-6 py-4 text-sm font-medium text-white"
                        >
                          Ad no.
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-4 text-sm font-medium text-white"
                        >
                          Post Date
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-4 text-sm font-medium text-white"
                        >
                          Party Name
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-4 text-sm font-medium text-white"
                        >
                          Category
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-4 text-sm font-medium text-white"
                        >
                          Action
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-4 text-sm font-medium text-white"
                        >
                          Status
                        </th>
                      </tr>
                    </thead>

                    <tbody className="font-Acme">
                      

                      {adsList.length > 0 ? (
                        <>
                          {" "}
                          {adsList.slice(0, `${viewMore ? 10: adsList.length}`).map((item, index) => {
                            return (
                              <tr className="border-b bg-white" key={index}>
                                <td className="whitespace-nowrap px-6 py-4 text-sm font-light text-gray-900">
                                  {index + 1}
                                </td>
                                <td className="whitespace-nowrap px-6 py-4 text-sm font-light text-gray-900">
                                  {item.id}
                                </td>
                                <td className="whitespace-nowrap px-6 py-4 text-sm font-light text-gray-900">
                                  {item.created_at}
                                </td>
                                <td className="whitespace-nowrap px-6 py-4 text-sm font-light text-gray-900">
                                  {/* Intelzy */}
                                  {item.title}
                                </td>
                                <td className="whitespace-nowrap px-6 py-4 text-sm font-light text-gray-900">
                                  {/* category */}
                                  {item.type}
                                </td>
                                <td className="whitespace-nowrap rounded-full py-2 px-4 text-sm font-bold">
                                  <button
                                    data-bs-toggle="modal"
                                    data-bs-target="#exampleAdsEdit"
                                    className="bg-primary-blue ml-10 inline-flex gap-2 rounded-md px-5 py-3 font-bold text-white"
                                    onClick={()=> {setAdsId(item.id)}}>
                                    View/edit
                                  </button>

                                  <EditAddList adsId={adsId} />

                                  <button
                                    onClick={() => deleteAdd(item.id)}
                                    className="bg-primary-red ml-10 inline-flex gap-2 rounded-md px-5 py-3 font-bold text-white"
                                  >
                                    delete
                                  </button>

                                </td>
                                <td className="text-primary-blue whitespace-nowrap rounded-full py-2 px-4 text-sm font-bold">
                                  {item.is_active === true ? (
                                    <>
                                      {" "}
                                      <div className="bg-primary-green ml-10 inline-flex gap-2 rounded-md px-5 py-3 font-bold text-white">
                                        Show
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      <div className="bg-primary-green ml-10 inline-flex gap-2 rounded-md px-5 py-3 font-bold text-white">
                                        Hidden
                                      </div>
                                    </>
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                        </>
                      ) : (
                        <>
                          <tr className="w-full flex justify-center m-3">
                            No Data Found
                          </tr>
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
                <div className="bg-primary-blue ml-10 mt-3 inline-flex gap-2 rounded-md px-5 py-3 font-bold text-white">
                  <a href="">Print</a>
                </div>
                <div className="bg-primary-green ml-10 mt-3 inline-flex gap-2 rounded-md px-5 py-3 font-bold text-white">
                {viewMore ? <button onClick={() => setViewMore(false)}>View More</button> :
                        <button onClick={()=> setViewMore(true)}>View Less</button>
                    }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* end table */}
    </div>
  );
};

export default AdsList;
